import React, { useState } from 'react';
import "./contact.css";
import Navbar from '../../components/navbar/navbar';
import { IoIosArrowDown } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import Footer from '../../components/footer/footer';
import Loader from '../../components/loader/loader';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../api/api'

const Contact = () => {
  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false)

  const toggleQuestion = (index) => {
    setExpandedQuestion(expandedQuestion === index ? null : index);
  };

  
  const faqData = [
    {
      question: "How does this work?",
      answer: "It’s a coding adventure! 🚀 Each week, your child joins a live, one-on-one online class with a friendly instructor who guides them through fun, hands-on coding lessons. They’ll build their own games and software projects while learning step by step in a way that makes sense to them. \n\nSince classes are one-on-one, lessons are personalized—helping your child master challenging concepts while excelling in the areas where they shine. No need to travel—just log in, join the class, and start coding! 🎉"
    },
    {
      question: "How do I get started?",
      answer: "1️⃣ Click Get Started to begin.\n\n2️⃣ Choose a weekly class time that works best for you.\n\n3️⃣ Check your email for a confirmation after signing up.\n\n4️⃣ Log into your account when it’s time for class.\n\n5️⃣ Meet your teacher and get ready to code!\n\n6️⃣ Start learning and have fun! 🚀"
    },
    /*{
      question: "Can I reschedule a class?",
      answer: "Classes can’t be rescheduled since teachers have set schedules, so it’s important to attend at the time you’ve selected. To make sure your student gets the most out of their lessons, be sure to mark class times on the calendar and join class five minuites before the start time.😊"
    },*/
    {
      question: "Can I change my class time?",
      answer: "Yes, you can! But changing your class time may result in being scheduled with a different teacher. Since each teacher follows a structured curriculum, switching teachers can sometimes disrupt the learning flow. To keep things consistent and ensure the best learning experience, class changes are limited to once every six months. If you’re considering a change, be sure to pick a time that will work long-term!📅"
    }
  ];

  const handleSubmit = async () => {
    if (email == '' || message == '') {
      toast.error("Fill all fields.")
    } else {
      setLoading(true)
      await api.post(`${process.env.REACT_APP_API_URL}/submit-inquiry`, {
        customerEmail: email, message
      }).then((res) => {
         setLoading(false)
         toast.success('Success, we will reach out via email!')
      }).catch((err) => {
        console.log(err)
        toast.error('Error,try again later.')
        setLoading(false)
      })
    }
  }

  return (
    <div className='contact-page'>
      <ToastContainer />
        <Navbar />

        {
          loading === true ?
          <div className='contact-loading'>
            <Loader />
          </div>
          :
          <div className='contact-body'>
            <div className='contact-left'>
                <h1>F.A.Q</h1>

                <div className='questions'>
                    {faqData.map((item, index) => (
                    <div key={index} className='question'>

                        <div className='question-header' onClick={() => toggleQuestion(index)}>
                            <p>{item.question}</p>
                            <IoIosArrowDown
                                size={32}
                                className={`arrow-icon ${expandedQuestion === index ? "rotate" : ""}`}
                            />
                        </div>

                        <div className={`answer ${expandedQuestion === index ? "show" : ""}`}>
                            <p>{item.answer}</p>
                        </div>
                    </div>
                    ))}
                </div>


                <div className='display-card-containers'>
                    <div className='contact-card-one'>
                        <h3>Customer Support <FaPhoneAlt className='support-icon' size={18} /></h3>

                        <p>
                          Reach out to our customer support team any time! Our friendly space cadets are here to help.
                        </p>
                    </div>

                    <div className='contact-card-two'>
                      <h3>F.A.Q <HiOutlineSpeakerphone className='support-icon' size={20} /></h3>

                      <p>
                      Looking for answers? Check out our FAQs above! We’ve covered the most common questions to help you find a solution quickly. If you still need assistance, send us a message!
                      </p>
                    </div>
                </div>
            </div>

            <div className='contact-right'>
                <h1 className='contact-header'>Contact Us</h1>

                <p className='contact-prompt'>
                    Hi friend, we're always here to help. If you have any questions or concerns submit a inquiry below.  
                </p>

                

                <div className='email-box-container'>
                    <p>Email:</p>
                    <input value={email} onChange={(e)=>setEmail(e.target.value)} type="text" />
                </div>

                <div className='message-box-container'>
                    <p>Message:</p>
                    <textarea value={message} onChange={(e)=>setMessage(e.target.value)} ></textarea>
                </div>

                <button onClick={()=>handleSubmit()} className='submit-button'>Submit</button>
            </div>
          </div>
        }

        <Footer />
    </div>
  )
}

export default Contact